import { createActionGroup, props } from '@ngrx/store';
import { LessonDto } from './lesson.dto';

export const LessonActions = createActionGroup({
  source: 'lesson API',
  events: {
    'Get Lessons By Day Success': props<{ lessons: LessonDto[] }>(),
    'Get Lessons By Day Failure': props<{ error: Error }>(),
  },
});
